<template>
  <Form ref="form" @submit.prevent>
    <div class="row g-4">
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("dataInicialCriacao") }}</label>
        <DateInput v-model="filters.creationInitialDate" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("dataFinalCriacao") }}</label>
        <DateInput v-model="filters.creationEndDate" :required="filters.creationInitialDate !== ''" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("dataInicialDeEncerramento") }}</label>
        <DateInput v-model="filters.closingInitialDate" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("dataFinalDeEncerramento") }}</label>
        <DateInput v-model="filters.closingEndDate" :required="filters.closingInitialDate !== ''" />
      </div>

      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("status") }}</label>
        <StatusDropdown v-model="filters.status" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("usuario") }}</label>
        <UsersDropdown v-model="filters.users" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("cliente") }}</label>
        <ClientesDropdown v-model="filters.clientes" />
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="form-label">{{ $t("servico") }}</label>
        <ServicosDropdown v-model="filters.servicos" />
      </div>
    </div>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
      <LoadingButton class="btn-primary" :loading="loading" @click="onClick">
        <i class="bi bi-filetype-pdf" /> {{ $t("download") }}
      </LoadingButton>
    </div>
  </Form>
</template>

<script>
import Form from '@/modules/core/components/FormInput.vue';
import DateInput from '@/modules/core/components/DateInput.vue';
import StatusDropdown from '@/modules/shared/components/StatusDropdown.vue';
import UsersDropdown from '@/modules/shared/components/UsersDropdown.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import ClientesDropdown from '@/modules/shared/components/ClientesDropdown.vue';
import ServicosDropdown from '@/modules/shared/components/ServicosDropdown.vue';

export default {
  components: {
    Form,
    DateInput,
    StatusDropdown,
    UsersDropdown,
    LoadingButton,
    ClientesDropdown,
    ServicosDropdown,
  },
  props: {
    loading: { type: Boolean, required: true },
  },
  emits: ['filter'],
  data: () => ({
    filters: {
      creationInitialDate: '',
      creationEndDate: '',
      closingInitialDate: '',
      closingEndDate: '',
      search: '',
      status: [0, 1, 2, 3, 5],
      users: [],
      clientes: [],
      servicos: [],
    },
  }),
  methods: {
    onClick() {
      if (this.validateDate()) {
        if (this.$refs.form.validate()) {
          this.$emit('filter', this.filters);
        }
      }
    },
    validateDate() {
      if (this.filters.closingInitialDate !== '') {
        if (new Date(this.filters.closingInitialDate) > new Date(this.filters.closingEndDate)) {
          useToast().error(ref(computed((_) => i18n.global.t('dataInicialEncerramentoMaiorQueFinal'))));
          return false;
        }
      }
      if (this.filters.creationInitialDate !== '') {
        if (new Date(this.filters.creationInitialDate) > new Date(this.filters.creationEndDate)) {
          useToast().error(ref(computed((_) => i18n.global.t('dataInicialCriacaoMaiorQueFinal'))));
          return false;
        }
      }
      return true;
    },
  },
};
</script>
